import { housesDict } from "../HouseInfo";
import Property from "../../components/Property/Property";

function CondoFourOne() {
  return (
    <div>
      {/* <Property {...housesDict["C004"]} /> */}
      <Property
        {...{
          housesDict: housesDict["C004"],
          propertyId: "65c1b95f3886dd758c1690a4",
        }}
      />
    </div>
  );
}

export default CondoFourOne;
